<template>
  <div class="sports-page">
    <meta-content></meta-content>
    <v-layout class="page-layout">
      <v-flex class="main-column" :style="{paddingTop: headerHeight + 'px'}" ref="maincolumn">
        <racing-iframe></racing-iframe>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  // import config from '@/config'
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'
  import MetaContent from '@/components/sports/bettingoffer/metaContent'
  import HeaderPart from '@/components/layout/parts/HeaderPart'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import RacingIframe from '@/components/externalintegrations/racing/RacingIframe'
  import scrollToTop from '@/library/scrollToTop.js'

  export default {
    name: 'RacingPage',

    mixins: [
      Screen
    ],

    components: {
      MetaContent,
      HeaderPart,
      SiteNavigation,
      RacingIframe
    },

    data () {
      return {
      }
    },

    computed: {
      headerHeight () { return store.getters['screenState/getHeaderHeight'] }
    },

    methods: {
      mainColumnResize () {
        var mainColumn = this.$refs.maincolumn
        if (mainColumn) {
          store.commit('screenState/setMainColumnWidth', mainColumn.offsetWidth)
        }
      }
    },

    mounted () {
      this.mainColumnResize()
      scrollToTop('smooth')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/RacingPage.vue